<template>
  <el-dialog title="" :visible.sync="show" width="1600px" top="2vh">
    <iframe
      src="http://120.26.202.178:10035/CFCM/#/cucumber/index"
      frameborder="0"
      style="width: 1560px; height: 920px"
    ></iframe>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/welcome/LandGuideFertilizerDialog.vue